import gql from 'graphql-tag';

export const updateAvatarMutation = gql`
  mutation updateUserAvatar($file: Upload!) {
    updateUserAvatar(file: $file) {
      fileUrl
    }
  }
`;
